import {AuthService} from 'app/core/services/auth.service';
import {isObject} from 'app/core/helpers/object';
import {ThemeCustomizationService} from 'app/core/services/theme-customization.service';

export function fetchAuthorizedUserFactory(auth: AuthService, themeService: ThemeCustomizationService) {
    return () =>
        auth
            .init()
            .then(user => {
                if (!isObject(user)) {
                    return;
                }
                themeService.init(user);
            })
            .catch(e => {
                auth.initError = e;
                console.error('fetchAuthorizedUserFactory', e);
            });
}
